// src/utils/loginAppearance.js
// Single source of truth for the (admin-configurable) login page appearance.
// Both the Login page and the admin Settings editor import these defaults so
// they never drift apart. Anything saved via the Settings page is merged on
// top of these defaults, so older/partial saved payloads still render safely.

export const DEFAULT_LOGIN_APPEARANCE = {
  // Brand
  brandName:   'Guru Punvaanii',
  logoUrl:     '/gpp-logo.png',
  tagline:     'Fair Policy | Fair Property',

  // Form copy
  heading:        'Welcome Back!',
  subheading:     '',
  usernameLabel:  'Username',
  passwordLabel:  'Password',
  buttonText:     'Sign In',

  // Optional controls
  showRememberMe:     true,
  showForgotPassword: true,
  forgotPasswordText: 'Forgot Password?',
  forgotPasswordUrl:  '',

  // Left showcase panel
  panelTitle:    'Manage Properties Efficiently',
  panelSubtitle: 'Easily track EOI submissions, projects, and buyer communications in one place.',
  images: [
    'https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=1200&q=80',
    'https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=1200&q=80',
    'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1200&q=80',
  ],
  carouselInterval: 5,      // seconds between slides (0 = no auto-advance)
  panelOverlay:     0.45,   // 0..1 dark overlay over the images for text contrast

  // Theme
  primaryColor:     '#b8862e',
  primaryColorDark: '#d4a04a',

  footerText: '© 2026 Guru Punvaanii',
};

// Merge a (possibly partial / possibly null) saved payload onto the defaults.
// Guarantees every field exists with a sensible value.
export function mergeAppearance(saved) {
  const a = { ...DEFAULT_LOGIN_APPEARANCE, ...(saved && typeof saved === 'object' ? saved : {}) };
  // Normalise the image list: drop blanks, ensure it's an array.
  a.images = Array.isArray(a.images)
    ? a.images.map(s => (s || '').trim()).filter(Boolean)
    : [];
  if (!a.images.length) a.images = DEFAULT_LOGIN_APPEARANCE.images.slice();
  const ci = Number(a.carouselInterval);
  a.carouselInterval = Number.isFinite(ci) && ci >= 0 ? ci : DEFAULT_LOGIN_APPEARANCE.carouselInterval;
  const ov = Number(a.panelOverlay);
  a.panelOverlay = Number.isFinite(ov) ? Math.min(1, Math.max(0, ov)) : DEFAULT_LOGIN_APPEARANCE.panelOverlay;
  return a;
}
